import UPCheckbox from './UPCheckbox';

export default UPCheckbox;
